// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-benchmark-item-detailed-report-button {
  margin-left: auto;
}
.fi-benchmark-item-detailed-report-button .detailed-report-icon {
  color: var(--fi-color-filter-grey-light);
  line-height: 40px !important;
}
.fi-benchmark-item-detailed-report-button .fi-info-icon {
  z-index: 1;
}

.select-business-unit-report-menu .business-unit-button .report-button-icon,
.select-business-unit-report-menu .business-unit-button .report-button-label {
  color: var(--fi-color-steel-grey);
}
.select-business-unit-report-menu .business-unit-button .report-button-icon {
  margin: 0;
  line-height: 24px;
}
.select-business-unit-report-menu .business-unit-button .report-button-label {
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-report/components/checklist-history-report/unit-performance-benchmark/benchmark-item-detailed-report-button/fi-benchmark-item-detailed-report-button.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAAI;EACI,wCAAA;EACA,4BAAA;AAER;AAAI;EACI,UAAA;AAER;;AAIQ;;EAEI,iCAAA;AADZ;AAGQ;EACI,SAAA;EACA,iBAAA;AADZ;AAGQ;EACI,gBAAA;EACA,eAAA;EACA,sBAAA;AADZ","sourcesContent":[".fi-benchmark-item-detailed-report-button {\r\n    margin-left: auto;\r\n    .detailed-report-icon {\r\n        color: var(--fi-color-filter-grey-light);\r\n        line-height: 40px !important;\r\n    }\r\n    .fi-info-icon {\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n.select-business-unit-report-menu {\r\n    .business-unit-button {\r\n        .report-button-icon,\r\n        .report-button-label {\r\n            color: var(--fi-color-steel-grey);\r\n        }\r\n        .report-button-icon {\r\n            margin: 0;\r\n            line-height: 24px;\r\n        }\r\n        .report-button-label {\r\n            font-weight: 400;\r\n            font-size: 14px;\r\n            letter-spacing: 0.25px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
